import types from './types';
import {
    fetchElementsPaginated
} from './common';


const apiUrl = '/api/invoices';


export function fetchInvoicesPaginated(page = 0, size = 10) {
    return fetchElementsPaginated(`${apiUrl}/paginated`, page, size, types.ADMIN_LOAD_INVOICES);
}




// WEBPACK FOOTER //
// ./src/js/actions/invoices.js